<template>
  <div class="orders">
    <h1>
      Ordrar
    </h1>

    <div class="filter">
      <select name="filter" v-model="filter">
        <option value="all">
          Alla
        </option>
        <option value="waiting">
          Väntande
        </option>
      </select>
    </div>

    <div class="order-quantity">
      <div class="group">
        <ul class="group-item-list">
          <li class="group-item">
            <span class="order-quantity-name">Ordrar totalt</span> {{ filteredOrders.length }}
          </li>
        </ul>
      </div>

      <template v-if="menuItems">
        <div class="group" v-for="(items, type) of groupedOrders" :key="type">
          <ul class="group-item-list">
            <li class="group-item">
              <span class="order-quantity-name">{{ type }}</span>
              <strong>{{ groupSum(items) }}</strong>
            </li>
            <li class="group-item" v-for="([id, qty]) in sortedItems(items)" :key="id">
              <span class="group-item-name"> {{ itemFor(id) }}</span> {{ qty }}
            </li>
          </ul>
        </div>
      </template>
    </div>

    <ul class="orders">
      <li v-for="order in filteredOrders" :key="order.id" class="order">
        <h2>{{ getTime(order.timeslot) }}</h2>
        <span class="detail meta">#{{ order.id }} - {{ new Date(order.created_at).toLocaleString('sv-SE') }}</span>

        <div class="customer">
          <span class="name">{{ order.customer.name }}</span>
          <span class="detail">{{ order.customer.phone }}</span>
          <span class="detail">{{ order.customer.email }}</span>

          <div class="detail" v-if="order.customer.comment">
            Kommentar:
            {{ order.customer.comment }}
          </div>
        </div>

        <ul class="items">
          <li class="item" v-for="item in order.items" :key="item.id">
            {{ item.quantity }} x {{ item.name }} <span class="price">{{ item.price }}</span>
          </li>
        </ul>

        <p class="order-total">
          Totalt: {{ order.total }}
        </p>

        <OrderActions :order="order" />
      </li>
    </ul>
  </div>
</template>

<script>
  import OrderActions from 'components/admin/order-actions';
  import { mapState } from 'vuex';
  import { getTime } from '@/lib/timeslots.js';

  export default {
    name: 'Orders',
    components: {
      OrderActions
    },
    data () {
      return {
        filter: 'waiting',
        menuItems: null,
        groupedOrdersTest: null
      };
    },
    computed: {
      ...mapState('order', ['orders']),

      filteredOrders () {
        if (this.filter === 'waiting') {
          return this.orders.filter(o => o.state !== 'completed');
        } else {
          return this.orders;
        }
      },

      groups () {
        return this.menu[0].data.body.map(i => {
          return { type: i.primary.type, ids: i.items.map(i => i.menu_item.id) };
        });
      },

      groupedOrders () {
        const groups = {};

        for (const order of this.filteredOrders.map(o => o.items)) {
          for (const item of order) {
            const type = this.groupFor(item.id);
            groups[type] = groups[type] || {};
            groups[type][item.id] = groups[type][item.id] || 0;
            groups[type][item.id] = groups[type][item.id] + item.quantity;
          }
        }

        return groups;
      }
    },

    mounted () {
      this.getMenu();
    },

    methods: {
      itemFor (id) {
        const item = this.menuItems.find(i => i.id === id);
        return item?.data?.name ?? 'Borttagen produkt';
      },

      groupFor (id) {
        const g = this.groups.find(g => g.ids.includes(id));
        return (g && g.type) || 'Unknown';
      },

      getTime (int) {
        return getTime(parseInt(int)).time;
      },

      changeFilter () {
        this.filter = this.filter === null ? 'waiting' : null;
      },

      groupSum (items) {
        return Object.entries(items).reduce((sum, item) => sum + item[1], 0);
      },
      async getMenu () {
        this.menu = window.prismicData.results.filter(document => document.type === 'menu');
        this.menuItems = window.prismicData.results.filter(document => document.type === 'menu_item');
      },

      sortedItems (items) {
        const sortedItems = Object.entries(items).sort(function (a, b) {
          return b[1] - a[1];
        });

        return sortedItems;
      }

    }
  };
</script>

<style lang="stylus" scoped>
  @require '~global/colors'
  @require '~global/typo-admin'
  @require '~global/helpers'

  .orders
    max-width: 600px
    margin: 0 auto

  h1
    @extend .t-header
    text-align: center

  h2
    @extend .t-subHeader
    font-size: 1.2rem
    margin-bottom: 0

  .order-quantity
    margin: 1rem 0 0 0

  .meta
    margin-bottom: 1rem

  .name
    font-weight: 400

  .detail
    font-size: 0.8rem
    display: block

  .customer, .items
    margin-bottom: 1rem

  .order
    border-bottom: 1px solid rgb(160,160,160)
    padding: 4rem 0 2rem 0

  .order-totals
    margin-bottom: 1rem

  .group
    margin-bottom: 1rem
    width: 240px

  .group-item
    display flex

  .group-item-name,
  .order-quantity-name
    margin-right: auto

  .order-quantity-name
    font-weight: 500

  .price
    margin-left: auto
    display: block
    font-style: italic
    font-size: 0.9rem

  .price:after,
  .order-total:after
    content: ":-"
    position: relative

  .order-total
    font-weight: 500
    margin-bottom: 3rem

  .order-total:after
    left: -0.2rem
</style>
